import moment from 'moment'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'

interface FlightDealAvailabilityCtaParams {
  isOfferPage: boolean
  checkInDate?: string
  checkOutDate?: string
  duration?: number
  travelPeriods?: Array<App.FlightDealTravelPeriod>
}

function getSelectedCheckOutDate(checkInDate: string, checkOutDate?: string, duration?: number): string | undefined {
  if (checkOutDate) return checkOutDate
  if (!duration) return undefined
  return moment(checkInDate).add(duration, 'days').format(ISO_DATE_FORMAT)
}

function selectedDatesMatchTravelPeriods(checkInDate: string, checkOutDate: string, travelPeriods: Array<App.FlightDealTravelPeriod> = []): boolean {
  return travelPeriods.some((period) => {
    return moment(checkInDate).isBetween(period.departureDate, period.arrivalDate, 'day', '[]') &&
      moment(checkOutDate).isBetween(period.departureDate, period.arrivalDate, 'day', '[]')
  })
}

export function shouldShowFlightDealAvailabilityCta(params: FlightDealAvailabilityCtaParams): boolean {
  const { isOfferPage, checkInDate, checkOutDate, duration, travelPeriods } = params

  if (!isOfferPage) return false
  if (!checkInDate) return true

  const selectedCheckOutDate = getSelectedCheckOutDate(checkInDate, checkOutDate, duration)
  if (!selectedCheckOutDate) return true

  return !selectedDatesMatchTravelPeriods(checkInDate, selectedCheckOutDate, travelPeriods)
}
